import { Component, effect, input, OnDestroy } from '@angular/core';
import { PreviewCard } from './preview-card.class';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { TruncateWordsPipe } from '../../pipes/truncate-words.pipe';
import { BootstrapQueryService } from 'src/app/home-page/services/bootstrap-query.service';

@Component({
  selector: 'cgw-preview-card',
  standalone: true,
  imports: [CommonModule, TruncateWordsPipe],
  templateUrl: './preview-card.component.html',
  styleUrl: './preview-card.component.scss',
})
export class PreviewCardComponent implements OnDestroy {
  private readonly _cardChange = new Subject<boolean>();

  public readonly previewCard = input.required<PreviewCard>();

  public backgroundImage: string;

  constructor(private bootstrapQueryService: BootstrapQueryService) {
    this.manageCardChange();
  }

  public onClick(): void {
    this.previewCard()?.onClick?.();
  }

  public ngOnDestroy(): void {
    this._cardChange.next(true);
    this._cardChange.complete();
  }

  private manageCardChange(): void {
    effect(() => {
      if (!this.previewCard()) return;
      this._cardChange.next(true);
      this.bootstrapQueryService
        .getImageQuery(this.previewCard().backgroundImages)
        .pipe(takeUntil(this._cardChange))
        .subscribe((image) => {
          this.backgroundImage = image;
        });
    });
  }
}
